// Mock for the `patient_medications` table (immutable rows — one prescription
// event each). When the real entity ships, replace getPatientMedications() /
// insertPatientMedication() with Platform API calls.

/* ─────────────────────────────────────────────
   In-memory store (keyed by withings_user_id)
───────────────────────────────────────────── */
const STORE = {
  // Samuel Attia — aggressive titration, still uncontrolled
  '7572654': [
    {
      medication_id: 'med-sa-001',
      withings_user_id: 7572654,
      care_period_id: null,
      previous_medication_id: null,
      medication_class: 'arb',
      drug_name: 'losartan',
      brand_name: null,
      form: 'tablet',
      dose: '50mg',
      frequency: 'daily',
      route: 'oral',
      sig: 'Take 1 tablet by mouth once daily',
      quantity: 30,
      refills: 3,
      event_type: 'initiation',
      discontinue_reason: null,
      prescribed_by: 'Doctor Tarzan, PharmD',
      prescriber_npi: '1234567890',
      reviewed_by: null,
      reviewed_at: null,
      pharmacist_notes: null,
      source: 'pharmacist',
      ehr_prescription_id: null,
      prescribed_at: '2025-08-10',
      started_at: '2025-08-10',
      created_at: '2025-08-10T00:00:00Z',
    },
    {
      medication_id: 'med-sa-002',
      withings_user_id: 7572654,
      care_period_id: null,
      previous_medication_id: 'med-sa-001',
      medication_class: 'arb',
      drug_name: 'losartan',
      brand_name: null,
      form: 'tablet',
      dose: '100mg',
      frequency: 'daily',
      route: 'oral',
      sig: 'Take 1 tablet by mouth once daily',
      quantity: 30,
      refills: 3,
      event_type: 'dose-increase',
      discontinue_reason: null,
      prescribed_by: 'Doctor Tarzan, PharmD',
      prescriber_npi: '1234567890',
      reviewed_by: null,
      reviewed_at: null,
      pharmacist_notes: null,
      source: 'pharmacist',
      ehr_prescription_id: null,
      prescribed_at: '2025-09-22',
      started_at: '2025-09-22',
      created_at: '2025-09-22T00:00:00Z',
    },
    {
      medication_id: 'med-sa-003',
      withings_user_id: 7572654,
      care_period_id: null,
      previous_medication_id: null,
      medication_class: 'ccb',
      drug_name: 'amlodipine',
      brand_name: null,
      form: 'tablet',
      dose: '5mg',
      frequency: 'daily',
      route: 'oral',
      sig: 'Take 1 tablet by mouth once daily',
      quantity: 30,
      refills: 3,
      event_type: 'initiation',
      discontinue_reason: null,
      prescribed_by: 'Doctor Tarzan, PharmD',
      prescriber_npi: '1234567890',
      reviewed_by: null,
      reviewed_at: null,
      pharmacist_notes: null,
      source: 'pharmacist',
      ehr_prescription_id: null,
      prescribed_at: '2025-11-05',
      started_at: '2025-11-05',
      created_at: '2025-11-05T00:00:00Z',
    },
    {
      medication_id: 'med-sa-004',
      withings_user_id: 7572654,
      care_period_id: null,
      previous_medication_id: 'med-sa-003',
      medication_class: 'ccb',
      drug_name: 'amlodipine',
      brand_name: null,
      form: 'tablet',
      dose: '10mg',
      frequency: 'daily',
      route: 'oral',
      sig: 'Take 1 tablet by mouth once daily',
      quantity: 30,
      refills: 3,
      event_type: 'dose-increase',
      discontinue_reason: null,
      prescribed_by: 'Doctor Tarzan, PharmD',
      prescriber_npi: '1234567890',
      reviewed_by: null,
      reviewed_at: null,
      pharmacist_notes: null,
      source: 'pharmacist',
      ehr_prescription_id: null,
      prescribed_at: '2026-01-12',
      started_at: '2026-01-12',
      created_at: '2026-01-12T00:00:00Z',
    },
    {
      medication_id: 'med-sa-005',
      withings_user_id: 7572654,
      care_period_id: null,
      previous_medication_id: null,
      medication_class: 'thiazide',
      drug_name: 'hctz',
      brand_name: null,
      form: 'tablet',
      dose: '25mg',
      frequency: 'daily',
      route: 'oral',
      sig: 'Take 1 tablet by mouth once daily',
      quantity: 30,
      refills: 3,
      event_type: 'initiation',
      discontinue_reason: null,
      prescribed_by: 'Doctor Tarzan, PharmD',
      prescriber_npi: '1234567890',
      reviewed_by: null,
      reviewed_at: null,
      pharmacist_notes: null,
      source: 'pharmacist',
      ehr_prescription_id: null,
      prescribed_at: '2026-02-08',
      started_at: '2026-02-08',
      created_at: '2026-02-08T00:00:00Z',
    },
  ],

  // Younes Brini — standard step therapy
  '36437208': [
    {
      medication_id: 'med-yb-001',
      withings_user_id: 36437208,
      care_period_id: null,
      previous_medication_id: null,
      medication_class: 'ace-inhibitor',
      drug_name: 'lisinopril',
      brand_name: null,
      form: 'tablet',
      dose: '10mg',
      frequency: 'daily',
      route: 'oral',
      sig: 'Take 1 tablet by mouth once daily',
      quantity: 30,
      refills: 3,
      event_type: 'initiation',
      discontinue_reason: null,
      prescribed_by: 'Doctor Tarzan, PharmD',
      prescriber_npi: '1234567890',
      reviewed_by: null,
      reviewed_at: null,
      pharmacist_notes: null,
      source: 'pharmacist',
      ehr_prescription_id: null,
      prescribed_at: '2025-09-01',
      started_at: '2025-09-01',
      created_at: '2025-09-01T00:00:00Z',
    },
    {
      medication_id: 'med-yb-002',
      withings_user_id: 36437208,
      care_period_id: null,
      previous_medication_id: 'med-yb-001',
      medication_class: 'ace-inhibitor',
      drug_name: 'lisinopril',
      brand_name: null,
      form: 'tablet',
      dose: '20mg',
      frequency: 'daily',
      route: 'oral',
      sig: 'Take 1 tablet by mouth once daily',
      quantity: 30,
      refills: 3,
      event_type: 'dose-increase',
      discontinue_reason: null,
      prescribed_by: 'Doctor Tarzan, PharmD',
      prescriber_npi: '1234567890',
      reviewed_by: null,
      reviewed_at: null,
      pharmacist_notes: null,
      source: 'pharmacist',
      ehr_prescription_id: null,
      prescribed_at: '2025-10-15',
      started_at: '2025-10-15',
      created_at: '2025-10-15T00:00:00Z',
    },
    {
      medication_id: 'med-yb-003',
      withings_user_id: 36437208,
      care_period_id: null,
      previous_medication_id: null,
      medication_class: 'ccb',
      drug_name: 'amlodipine',
      brand_name: null,
      form: 'tablet',
      dose: '5mg',
      frequency: 'daily',
      route: 'oral',
      sig: 'Take 1 tablet by mouth once daily',
      quantity: 30,
      refills: 3,
      event_type: 'initiation',
      discontinue_reason: null,
      prescribed_by: 'Doctor Tarzan, PharmD',
      prescriber_npi: '1234567890',
      reviewed_by: null,
      reviewed_at: null,
      pharmacist_notes: null,
      source: 'pharmacist',
      ehr_prescription_id: null,
      prescribed_at: '2025-12-10',
      started_at: '2025-12-10',
      created_at: '2025-12-10T00:00:00Z',
    },
    {
      medication_id: 'med-yb-004',
      withings_user_id: 36437208,
      care_period_id: null,
      previous_medication_id: null,
      medication_class: 'thiazide',
      drug_name: 'hctz',
      brand_name: null,
      form: 'tablet',
      dose: '12.5mg',
      frequency: 'daily',
      route: 'oral',
      sig: 'Take 1 tablet by mouth once daily',
      quantity: 30,
      refills: 3,
      event_type: 'initiation',
      discontinue_reason: null,
      prescribed_by: 'Doctor Tarzan, PharmD',
      prescriber_npi: '1234567890',
      reviewed_by: null,
      reviewed_at: null,
      pharmacist_notes: null,
      source: 'pharmacist',
      ehr_prescription_id: null,
      prescribed_at: '2026-02-01',
      started_at: '2026-02-01',
      created_at: '2026-02-01T00:00:00Z',
    },
  ],

  // Default — fallback for all other patients
  default: [
    {
      medication_id: 'med-def-001',
      withings_user_id: null,
      care_period_id: null,
      previous_medication_id: null,
      medication_class: 'ace-inhibitor',
      drug_name: 'lisinopril',
      brand_name: null,
      form: 'tablet',
      dose: '10mg',
      frequency: 'daily',
      route: 'oral',
      sig: 'Take 1 tablet by mouth once daily',
      quantity: 30,
      refills: 3,
      event_type: 'initiation',
      discontinue_reason: null,
      prescribed_by: 'Doctor Tarzan, PharmD',
      prescriber_npi: '1234567890',
      reviewed_by: null,
      reviewed_at: null,
      pharmacist_notes: null,
      source: 'pharmacist',
      ehr_prescription_id: null,
      prescribed_at: '2025-09-15',
      started_at: '2025-09-15',
      created_at: '2025-09-15T00:00:00Z',
    },
    {
      medication_id: 'med-def-002',
      withings_user_id: null,
      care_period_id: null,
      previous_medication_id: 'med-def-001',
      medication_class: 'ace-inhibitor',
      drug_name: 'lisinopril',
      brand_name: null,
      form: 'tablet',
      dose: '20mg',
      frequency: 'daily',
      route: 'oral',
      sig: 'Take 1 tablet by mouth once daily',
      quantity: 30,
      refills: 3,
      event_type: 'dose-increase',
      discontinue_reason: null,
      prescribed_by: 'Doctor Tarzan, PharmD',
      prescriber_npi: '1234567890',
      reviewed_by: null,
      reviewed_at: null,
      pharmacist_notes: null,
      source: 'pharmacist',
      ehr_prescription_id: null,
      prescribed_at: '2025-10-28',
      started_at: '2025-10-28',
      created_at: '2025-10-28T00:00:00Z',
    },
    {
      medication_id: 'med-def-003',
      withings_user_id: null,
      care_period_id: null,
      previous_medication_id: null,
      medication_class: 'ccb',
      drug_name: 'amlodipine',
      brand_name: null,
      form: 'tablet',
      dose: '5mg',
      frequency: 'daily',
      route: 'oral',
      sig: 'Take 1 tablet by mouth once daily',
      quantity: 30,
      refills: 3,
      event_type: 'initiation',
      discontinue_reason: null,
      prescribed_by: 'Doctor Tarzan, PharmD',
      prescriber_npi: '1234567890',
      reviewed_by: null,
      reviewed_at: null,
      pharmacist_notes: null,
      source: 'pharmacist',
      ehr_prescription_id: null,
      prescribed_at: '2025-12-03',
      started_at: '2025-12-03',
      created_at: '2025-12-03T00:00:00Z',
    },
    {
      medication_id: 'med-def-004',
      withings_user_id: null,
      care_period_id: null,
      previous_medication_id: 'med-def-003',
      medication_class: 'ccb',
      drug_name: 'amlodipine',
      brand_name: null,
      form: 'tablet',
      dose: '10mg',
      frequency: 'daily',
      route: 'oral',
      sig: 'Take 1 tablet by mouth once daily',
      quantity: 30,
      refills: 3,
      event_type: 'dose-increase',
      discontinue_reason: null,
      prescribed_by: 'Doctor Tarzan, PharmD',
      prescriber_npi: '1234567890',
      reviewed_by: null,
      reviewed_at: null,
      pharmacist_notes: null,
      source: 'pharmacist',
      ehr_prescription_id: null,
      prescribed_at: '2026-01-18',
      started_at: '2026-01-18',
      created_at: '2026-01-18T00:00:00Z',
    },
    {
      medication_id: 'med-def-005',
      withings_user_id: null,
      care_period_id: null,
      previous_medication_id: null,
      medication_class: 'thiazide',
      drug_name: 'hctz',
      brand_name: null,
      form: 'tablet',
      dose: '12.5mg',
      frequency: 'daily',
      route: 'oral',
      sig: 'Take 1 tablet by mouth once daily',
      quantity: 30,
      refills: 3,
      event_type: 'initiation',
      discontinue_reason: null,
      prescribed_by: 'Doctor Tarzan, PharmD',
      prescriber_npi: '1234567890',
      reviewed_by: null,
      reviewed_at: null,
      pharmacist_notes: null,
      source: 'pharmacist',
      ehr_prescription_id: null,
      prescribed_at: '2026-02-25',
      started_at: '2026-02-25',
      created_at: '2026-02-25T00:00:00Z',
    },
  ],
};

/* ─────────────────────────────────────────────
   BP periods between consecutive prescription events.
   Will come from a separate Withings measurements / measure_state query in production,
   using consecutive prescribed_at dates as window boundaries.
───────────────────────────────────────────── */
const BP_PERIODS = {
  '7572654': [
    { avgSystolic: 168, avgDiastolic: 102, maxSystolic: 185, maxDate: '2025-09-10' },
    { avgSystolic: 158, avgDiastolic: 96,  maxSystolic: 174, maxDate: '2025-10-15' },
    { avgSystolic: 150, avgDiastolic: 92,  maxSystolic: 168, maxDate: '2025-12-03' },
    { avgSystolic: 144, avgDiastolic: 88,  maxSystolic: 162, maxDate: '2026-01-28' },
  ],
  '36437208': [
    { avgSystolic: 162, avgDiastolic: 98,  maxSystolic: 178, maxDate: '2025-09-28' },
    { avgSystolic: 152, avgDiastolic: 92,  maxSystolic: 166, maxDate: '2025-11-20' },
    { avgSystolic: 145, avgDiastolic: 87,  maxSystolic: 158, maxDate: '2026-01-05' },
  ],
  default: [
    { avgSystolic: 158, avgDiastolic: 94,  maxSystolic: 172, maxDate: '2025-10-02' },
    { avgSystolic: 149, avgDiastolic: 90,  maxSystolic: 165, maxDate: '2025-11-10' },
    { avgSystolic: 142, avgDiastolic: 86,  maxSystolic: 156, maxDate: '2025-12-22' },
    { avgSystolic: 138, avgDiastolic: 84,  maxSystolic: 150, maxDate: '2026-02-05' },
  ],
};

/* ─────────────────────────────────────────────
   Public API (mirrors the future Platform API surface)
───────────────────────────────────────────── */

/**
 * Fetch all prescription rows for a patient, ordered by prescribed_at ASC.
 * Replace with a Platform API read: apiv2Get('patient-medications', { withings_user_id: userId }).
 */
export function getPatientMedications(userId) {
  const key = String(userId);
  const rows = STORE[key] ?? STORE['default'];
  return Promise.resolve([...rows]);
}

/**
 * BP periods between consecutive prescription events (future: derived from Withings measurements / measure_state).
 */
export function getBpPeriods(userId) {
  const key = String(userId);
  return BP_PERIODS[key] ?? BP_PERIODS['default'];
}

/**
 * Insert a new prescription row.
 * Replace with a Platform API write (Tier 4 event → patient_medications writer).
 */
export function insertPatientMedication(userId, rowData) {
  const key = String(userId);
  // Seed patient-specific store from default if first write for this patient
  if (!STORE[key]) {
    STORE[key] = (STORE['default'] ?? []).map(r => ({ ...r, withings_user_id: userId }));
  }

  // Resolve previous_medication_id for non-initiation events
  let previousId = null;
  if (rowData.event_type !== 'initiation') {
    const sameDrug = STORE[key].filter(r => r.drug_name === rowData.drug_name);
    if (sameDrug.length > 0) {
      const latest = sameDrug.reduce((a, b) => (a.prescribed_at > b.prescribed_at ? a : b));
      previousId = latest.medication_id;
    }
  }

  const newRow = {
    ...rowData,
    medication_id: crypto.randomUUID(),
    withings_user_id: userId,
    previous_medication_id: previousId,
    reviewed_by: null,
    reviewed_at: null,
    ehr_prescription_id: null,
    created_at: new Date().toISOString(),
  };

  STORE[key].push(newRow);
  return Promise.resolve(newRow);
}
